import React from 'react';
import FormPage from './formPage';
import LegalDetails from './legalDetails';
import FieldYesNo from './fields/fieldYesNo';
import FieldSelect from './fields/fieldSelect';
import FieldNumeric from './fields/fieldNumeric';
import FieldDate from './fields/fieldDate';
import FieldText from './fields/fieldText';
import FieldCheck from './fields/fieldCheck'
import logo_immatriculation from '../img/immatriculation.png'
import DatePicker from "react-datepicker";
import Select from 'react-select'
import edit_button from '../img/edit.png'
import Vehiculier from './vehiculier';
import waiter from '../img/wait_white.svg';
import img_cb from '../img/carte de crédit.svg'
import img_enveloppe from '../img/enveloppe.svg'
import api from '../apiConnector'
import cadenas from '../img/Cadenas.svg'
import logo_right from '../img/right.png'
import { FrontEcheancierFma } from './echeancier';
import echeancier from '../img/échéancier.svg'
import arrow_down from '../img/black_arrow_down.png'
import arrow_up from '../img/black_arrow_up.png'
import list_departements from './liste_departements'

/** FrontDetails3 - page d'informations spécifiques à FMA */

export default class FrontDetails3 extends FormPage {
    
    constructor(props) {
        super(props);
        this.title = 'Finalisons votre dossier'
        this.state = {
            vehiculierReady:false,
            resyncing:false,
            launching:false
        }
        this.nextTitle = 'Télécharger votre devis'
        const isMoto = this.props.devis.type == 'moto'
        this.vehiculeRef = React.createRef();
        this.vehiculier = isMoto ? new Vehiculier( this.props.devis.params.marque, ()=>{this.setState({vehiculierReady:true})} ) : false
    }

    componentDidUpdate() {
        super.componentDidUpdate()
        if ( this.props.devis.synchronized && this.state.resyncing ) {
            this.setState({resyncing:false})
        }
    }

    next() {
        const devis = this.props.devis
        if ( !devis.synchronized ) { // ||( !devis.getFma().ident_police )) {
            if ( !this.state.resyncing ) {
                this.setState({resyncing:true})
                this.props.resync()
            }
        }
        if ( devis.synchronized && !this.state.launching && devis.getFma().hasTarifs() ) {
            if ( devis.getFma().numero_police ) {
                this.props.setPage('payment3')
            } else {
                this.setState({launching:true})
                api.post(
                    {action : /*devis.getFma().numero_police ? 'fma_subscribe' :*/ 'fma_enregistrer',
                    id:devis.type+devis._id.$oid},
                    ()=>{ this.setState({launching:false}) },
                    ()=>{ this.setState({launching:false}) }
                )
            }
        }
    }



    back() {
        this.props.setPage('landing')
    }

    renderGoToAntecedents() {
        return <a className="right_anchor" onClick={()=>this.props.setPage('antecedents')}><img src={edit_button}/> Modifier la liste de vos antécédents</a>
    }


    renderAnnulation(container) {
        return <>
            <FieldDate field="ant_annulation_date" container={container} />
        </>
    }

    renderStupefiants(container) {
        return <>
            <FieldDate field="ant_stupefiants_date" container={container} />
            <FieldText field="ant_stupefiants_substance" container={container} />
            <FieldSelect field="ant_stupefiants_sinistre" container={container} />
            <FieldYesNo field="ant_stupefiants_recidive" container={container} />
        </>   
    }

    renderAlcool(container) {
        return <>
            <FieldDate field="ant_alcool_date" container={container} />
            <FieldSelect field="ant_alcool_taux" container={container} />
            <FieldSelect field="ant_alcool_sinistre" container={container} />
            <FieldYesNo field="ant_alcool_recidive" container={container} />
        </>
    }

    renderRetrait(container) {
        return <>
            <FieldDate field="ant_retrait_date" container={container} />
            <FieldNumeric field="ant_retrait_duree_mois" container={container} min="0" max="36" />
            <FieldSelect field="ant_retrait_motif_full" container={container} />
            <FieldYesNo field="ant_retrait_recidive" container={container} />
        </>
    }

    renderResiliation(container) {
        return <>
            <FieldDate field="ant_resiliation_date" container={container} />
            <FieldYesNo field="ant_resiliation_non_paiement" container={container}/>
            <FieldYesNo field="ant_resiliation_fausse_declaration" container={container}/>
            <FieldYesNo field="ant_resiliation_frequence_sinistres" container={container}/>
            <FieldYesNo field="ant_resiliation_autre_motif" container={container}/>
        </>   
    }

    parseDate(dateStr) {
        const [day, month, year] = dateStr.split('/');
        // Note: Month is 0-indexed (January is 0)
        return new Date(year, month - 1, day);
    }

    getYearsCeil(date_naissance) {
        // 1. Split the "dd/mm/yyyy" string
        const [day, month, year] = date_naissance.split('/').map(Number);
        
        // 2. Create Date object (Note: months are 0-indexed in JS, so subtract 1)
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();
        
        // 3. Calculate difference in milliseconds
        const diffInMs = today - birthDate;
        
        // 4. Convert to years (using 365.25 to account for leap years)
        const msInYear = 1000 * 60 * 60 * 24 * 365.25;
        const years = diffInMs / msInYear;
        
        // 5. Return rounded up value
        // If the difference is negative (future date), it returns 0 or the negative ceil.
        return Math.ceil(years);
    }

    optionsFmaSelected() {
        const {params} = this.props.devis
        return params.fma_available.map(
            (v,idx) => ({value:idx,label:v.marque+' '+v.modele+' '+v.cylindree})
        )
    }

    doRender(container) {
        const {devis} = this.props
        const fma = devis.getFma().setChoicesFromDevis().setFancy('-',' €')
        const params = devis.params
        const hasFma = !fma.error && fma.hasTarifs()
        const isMoto = devis.type == 'moto'
        const antRetrait = params.ant_retrait=='O'
        const antAnnulation = params.ant_annulation=='O'
        const antAlcool = params.ant_alcool=='O'
        const antStupefiants = params.ant_stupefiants=='O'
        const antResiliation = params.ant_resiliation=='O'
        const unsync = ! devis.synchronized
        const numero_police = fma.numero_police

        const selVehicle = params.fma_available ? params.fma_available[params.fma_selected] : false
        const selVehicleName = selVehicle ? selVehicle.marque+' '+selVehicle.modele+' '+selVehicle.cylindree : 'Non défini'

        this.hasNext = true

        if ( fma.calculating || this.state.resyncing || this.state.launching ) {
            this.nextTitle = <img src={waiter}/>
        } else if ( unsync ) {
            this.nextTitle = 'Recalculer le tarif'
        } else if ( devis.synchronized && !this.state.launching && hasFma ) {
            if ( !numero_police ) {
                this.nextTitle = 'Éditer votre devis'
            } else {
                this.nextTitle = 'Souscrire cette offre'
            }
        } else {
            this.hasNext = false
        }

        const maxMonths = Math.min( ( this.getYearsCeil( params.date_naissance )-14 )*12, 24 )

        if ( this.state.vehiculierReady &&( params.marque != this.vehiculier.getMarque() )) {
            this.vehiculier.selectMarque( params.marque )
        }

        const nonAssureRelevance = ( this.parseDate( params.date_acquisition ) < this.parseDate( params.date_effet ) )
        const nonAssure = ( params.hamon_deja_assure != 'O' )&& nonAssureRelevance

        return <>
            <div className="header_offre">Assur Discount</div>

            <div className="contentvbox">
                <h1 className="top_title" ref={this.vehiculeRef}>Vérifiez le modèle de votre véhicule</h1>
                    {params.fma_available ?<>
                    <p>Nous avons recherché un véhicule pour cette offre qui corresponde à {params.marque} {params.modele} ({params.cylindree})</p>
                    <a className="right_anchor" onClick={()=>this.props.setPage('vehicule')}><img src={edit_button}/> Faire une autre recherche véhicule</a>
                    
                    <FieldSelect field="fma_selected" container={container} options={ this.optionsFmaSelected() }/>
                    </>:<><p>
                    Pour cette offre, rien ne correspond à {params.marque} {params.modele} ({params.cylindree})
                    </p>
                    <a className="right_anchor" onClick={()=>this.props.setPage('vehicule')}><img src={edit_button}/> Faire une autre recherche véhicule</a>
                    </>}
            </div>

                <div className="contentvbox">
            
                    <h1 className="top_title">Votre expérience sur les 24 derniers mois</h1>
                    <FieldNumeric field="nb_mois_moto" container={container} min={0} max={maxMonths} label="Nombre de mois d'assurance moto"/>

                    <h2>Merci de détailler votre expérience sur moto par puissance de véhicule</h2>
                    <FieldNumeric field="ant_cylindree_399" container={container} min={0} max={maxMonths} />
                    <FieldNumeric field="ant_cylindree_599" container={container} min={0} max={maxMonths} />
                    <FieldNumeric field="ant_cylindree_9999" container={container} min={0} max={maxMonths} />
                </div>

                <div className="contentvbox">
            
                    <h1 className="top_title">Quelques dernières précisions</h1>
        
                    <FieldSelect field="situation_famille" container={container} />

                    <FieldSelect field="csp" container={container}/>
                    <FieldSelect field="mode_garage" container={container}/>
                    {['G','C'].includes(params.carte_grise_titulaire) 
                    ? <h3>Vous souscrivez au nom d'une société, donc pour un <b>usage professionnel</b></h3>
                    : <FieldSelect field="usage_auto" container={container}/>}

                    {(  parseInt( params.coefficient_moto ) <= 50 ) &&
                        <FieldNumeric field="nb_ans_bonus_50_moto" container={container} min={0} max={40}/>
                    }

                    <LegalDetails container={container} />

                    <FieldText field="commune_naissance" placeholder="Sans code postal. Exemple: Paris" label="Commune de naissance (si vous êtes né en France)" container={container} />
                    <FieldSelect field="departement_naissance" options={FieldSelect.listToOptions(list_departements,true)} container={container} label="Département de naissance (si vous êtes né en France)" notice="En toutes lettres (exemple SEINE-MARITIME)"/>
                    <FieldSelect field="pays_naissance" label="Pays de naissance (si vous êtes né à l'étranger)" container={container}/>

        
                    <h2>Pour cette offres, nous avons besoin de certains antécédents sur 60 mois</h2>
        
                    <FieldYesNo field="ant_alcool" container={container} label={<>Au cours des 60 derniers mois, vous avez fait l'objet d'une <b>sanction en état d'ébriété</b></>} />
                    {( params.ant_alcool=='O' )? this.renderAlcool(container) : '' }
        
                    <FieldYesNo field="ant_stupefiants" container={container} label={<>Au cours des 60 derniers mois, vous avez fait l'objet de poursuites ou condamnations pour conduite sous l'emprise de <b>stupéfiants, drogues ou médicaments non prescrits</b></>} />
                    {( params.ant_stupefiants=='O' )? this.renderStupefiants(container) : '' }
        
                    {antRetrait?<>
                        <h3><span>Retraits de permis</span></h3>
                        {this.renderGoToAntecedents()}
                        <label>Au cours des 60 derniers mois vous avez fait l'objet d'un retrait de permis</label>
                        {( params.ant_retrait=='O' )? this.renderRetrait(container) : '' }
                    </>:<></>}
        
                    {antAnnulation?<>
                        <h3><span>Annulation de permis</span></h3>
                        <label>Au cours des 60 derniers mois vous avez fait l'objet d'une annulation de permis</label>
                        {( params.ant_annulation=='O' )? this.renderAnnulation(container) : '' }
                    </>:<></>}
        
        
                    {antResiliation?<>
                        <h3><span>Résiliation d'assurance</span></h3>
                        <label>Au cours des 60 derniers mois vous avez fait l'objet d'une résiliation par un précédent assureur</label>
                        {( params.ant_resiliation=='O' )? this.renderResiliation(container) : '' }
                    </>:<></>}
        
                    {(!(antRetrait||antAlcool||antAnnulation||antResiliation||antStupefiants))
                    ? <><h2>Vous n'avez déclaré aucun antécédent (retrait, annulation de permis, sanctions sous emprise de l'alcool ou de stupéfiants, résiliations, ...)</h2>
                    </>
                    :''}
                    {this.renderGoToAntecedents()}
            </div>

            <div className="contentvbox">

                <h1 className="top_title">Édition du devis</h1>

                <FieldDate field="date_effet" container={container}/>
                
                { nonAssureRelevance && <FieldYesNo field="hamon_deja_assure" container={container} /> }

                { nonAssure && <FieldDate field="date_assure_precedement" container={container} /> }

                <FieldYesNo field="premier_contrat" container={container} />

                {(hasFma||unsync) && <div className="standalone_prices notice_box">
                        <div className="img_box"><img src={img_enveloppe}/></div>
                        <div className="text_box centered">
                            <p>
                            {numero_police ? <a className="button button_subscribe" href={api.downloadDevisFma(devis.typedId())} target="_blank">Télécharger votre devis</a>
                            : <a className="button button_subscribe" onClick={this.onSubmit.bind(this)} target="_blank">{this.nextTitle}</a>}
                            </p>
                        </div>
                </div>}
            </div>
            <div className="contentvbox">

                <h1 className="top_title">Souscription</h1>

                <FieldText field="immatriculation" notice="Exemple: XX123XX" container={container} noCheck={unsync || !numero_police} logo={logo_immatriculation} logoClass="immatriculation"/>

                <FieldText field="iban" 
                    logo={logo_right}
                    container={container} 
                    placeholder="27 caractères commençant par FR"
                    noCheck={unsync || !numero_police}/>
                <FieldText field="bic"
                    container={container}
                    noCheck={unsync || !numero_police}/>

                <FieldCheck field="own_iban" container={container} noCheck={unsync || !numero_police} disabled={!devis.getValue('iban','').trim()}/>

                <FieldCheck field="accept_cgu" container={container} noCheck={unsync || !numero_police}/>

                { this.props.embeded
                ? <FieldSelect 
                        field="frais_sup" container={container} options={devis.getOptionsFraisSup(api.isAdmin())} 
                        label={<>Les frais actuels sont de <b>{fma.frais} €</b>.<br/>Vous pouvez appliquer des frais supplémentaires, dans la limite de {devis.max_frais} € de frais totaux :</>}
                    /> : ''}
                    
                { unsync
                ? <div className="standalone_prices notice_box">
                    <div className="img_box"><img src={cadenas}/></div>
                    <div className="text_box">
                    Vos informations ont changé. <br/>
                    { ( this.state.resyncing || fma.calculating )?<>Calcul en cours...</>:<a onClick={this.onSubmit.bind(this)}>Cliquez ici pour relancer le calcul du tarif</a>}
                </div></div>
                : ( hasFma&&!this.state.resyncing ) ? <><div className="standalone_prices notice_box">
                        <div className="img_box"><img src={img_cb}/></div>
                        <div className="text_box">
                        {(params.periodicite=='M')?<>
                            <div className="price_row"><b>{fma.fancyPrice(fma.mensuel())}</b> par mois</div>
                            <div className="price_row"><b>{fma.fancyPrice(fma.coutTotal())}</b> par an TTC*</div>
                        </>:<>
                            <div className="price_row"><b>{fma.fancyPrice(fma.coutTotal())}</b> par an TTC*</div>
                        </>}
                        <p>* Frais de gestion et courtage inclus.<br/>
                        {(params.periodicite=='M')?<>
                        Le comptant de <b>{fma.fancyPrice(fma.comptantMensuel()+fma.fraisCB())}</b> comprend les frais de gestion et de courtage et les deux premiers mois de cotisation. Les frais de <b>{fma.fancyPrice(fma.fraisCB())}</b> sont renouvelables chaque année. <br/>
                        Puis, à partir du 3ème mois : <b>{fma.fancyPrice(fma.mensuel())}</b></>:<>
                        Le comptant de <b>{fma.fancyPrice(fma.coutTotal())}</b> comprend les frais de gestion et de courtage renouvelables chaque année, ainsi
                        que la première année d'assurance.
                        </>}
                        </p>
                        </div>                        
                    </div>
                    <label>Votre véhicule <span>{selVehicleName}</span></label>
                    <a className="right_anchor" onClick={
                        ()=>{
                            if (this.vehiculeRef.current) {
                                this.vehiculeRef.current.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        }
                    }><img src={edit_button}/> Ce n'est pas le modèle correct de mon véhicule</a>
                    <h2 className="clickbox"
                        onClick={()=>this.setState(state=>({collapseEcheancier:!state.collapseEcheancier}))}
                    >
                        <img src={echeancier}/> 
                        Votre <b>échéancier</b>
                        <img className="right_switch" src={this.state.collapseEcheancier ? arrow_down : arrow_up}/>
                    </h2>

                    <FrontEcheancierFma container={container} hidden={this.state.collapseEcheancier}/>
                    {fma.numero_police && <div className="standalone_prices notice_box">
                        <div className="img_box"><img src={img_enveloppe}/></div>
                        <div className="text_box centered">
                            <p>
                            <a className="button button_subscribe" href={api.downloadDevisFma(devis.typedId())} target="_blank">Télécharger votre devis</a>
                            <a className="button button_subscribe" onClick={()=>this.onSubmit()}>
                                {(fma.calculating || this.state.resyncing || this.state.launching )?<img src={waiter}/>:'Souscrire en ligne'}
                            </a>
                            </p>
                        </div>
                    </div>}
                    </>
                    : <div className="standalone_prices notice_box">
                        <div className="text_box centered">
                            {!!fma.calculating && <p>Nous recalculons votre devis, merci de patienter quelques secondes ...</p>}
                            
                            {fma.error && <><p className="error">Une erreur est survenue : {fma.getCleanError()}.</p> 
                            <ul>
                                <li>Vous pouvez modifier vos informations et relancer le calcul du devis,</li>
                                <li>Ou contacter nos conseillers au
                                    <p className="telephone_left">
                                    <a href="tel:0974772861">09 74 77 28 61</a>
                                    </p>
                                </li>
                            </ul>
                            </>}

                            {((!fma.error)&&(!fma.hasTarifs())&&(!fma.calculating))&&<p>Cette formule n'est pas disponible. Vous pouvez en choisir une autre en revenant à la page précédente.</p>}

                        </div>
                    </div>
                }

            </div>

        </>
    }
}
